import { render, staticRenderFns } from "./CampaignSummary.vue?vue&type=template&id=37b1a25e&"
import script from "./CampaignSummary.vue?vue&type=script&lang=js&"
export * from "./CampaignSummary.vue?vue&type=script&lang=js&"
import style0 from "./CampaignSummary.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1771009219/src/capas-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('37b1a25e')) {
      api.createRecord('37b1a25e', component.options)
    } else {
      api.reload('37b1a25e', component.options)
    }
    module.hot.accept("./CampaignSummary.vue?vue&type=template&id=37b1a25e&", function () {
      api.rerender('37b1a25e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Brand/Reports/CampaignSummary.vue"
export default component.exports